export var extractDateUpdated = function extractDateUpdated(jsonLd) {
  if (jsonLd.updated) {
    return jsonLd.updated;
  }
};